import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Snackbar, Alert, Fade, CircularProgress } from '@mui/material';
import loginbg from '../assets/images/test2.jpg';
import textBg from '../assets/images/textBg.svg';
import logo from '../assets/images/logo/logo.png';
import CustomInputBox from '../components/customInputBox/CustomInputBox';
import { Security, Lock } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingButton from '@mui/lab/LoadingButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Link from '@mui/material/Link';
import NewLogo from '../assets/images/logo/NewLogo.png';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { showSuccessSnackbar, showWarningSnackbar } from '../components/snackBar/snakbar';
import { MuiOtpInput } from 'mui-one-time-password-input';

const NewPassword = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  let navigate = useNavigate();

  let location = useLocation();
  let params = location.state;
  //console.log(params);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    password: false,
    cpassword: false,
  });
  const [state, setState] = useState({
    code: '',
    newPassword: '',
    confirmPassword: '',
    open: false,
    timer: '00:15',
    showCountdown: true,
    errorStatus: {
      code: false,
      newPassword: false,
      confirmPassword: false,
    },
    errorFields: {
      code: '',
      newPassword: '',
      confirmPassword: '',
      open: '',
    },
  });

  const [timeLeft, setTimeLeft] = useState(100);
  const TOTAL_TIME = 15;

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 5);
    }, 1000);

    if (timeLeft <= 0) {
      clearInterval(timer);
      // setTimeLeft(100)
      return;
    }
    return () => clearInterval(timer);
  }, [timeLeft, state.showCountdown]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        event.preventDefault();
        handleFormSubmission();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [state]);

  useEffect(() => {
    if (state.showCountdown) {
      const startTime = Date.parse(localStorage.getItem('startTime'));
      let seconds = 0;
      let minutes = 0;
      if (Date.parse(new Date()) - startTime < 90000) {
        const coutDown = setInterval(() => {
          const total = startTime + 90000 - Date.parse(new Date());
          seconds = Math.floor((total / 1000) % 60);
          minutes = Math.floor((total / 1000 / 60) % 60);
          console.log(minutes, seconds);
          setState((prev) => ({
            ...prev,
            timer: (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds),
          }));
          if (minutes == 0 && seconds == 0) {
            clearInterval(coutDown);
            setState((prev) => ({
              ...prev,
              showCountdown: false,
            }));
          }
        }, 1000);
      } else {
        setState((prev) => ({
          ...prev,
          showCountdown: false,
        }));
      }
    }
  }, [state.showCountdown]);

  async function resendCode() {
    let username = params.email;

    try {
      // Send confirmation code to user's email
      await Auth.forgotPassword(username)
        .then((data) => {
          localStorage.setItem('startTime', new Date());
          setState((prev) => ({
            ...prev,
            showCountdown: true,
          }));
          setTimeLeft(100);

          setState((prev) => ({
            ...prev,
            open: false,
            errorFields: {
              ...prev.errorFields,
              open: '',
            },
          }));
        })
        .catch((error) => {
          setState((prev) => ({
            ...prev,
            open: true,
            errorFields: {
              ...prev.errorFields,
              open: error.message,
            },
          }));
        });
    } catch (error) {
      console.log('error : ', error);
    }
  }

  let horizontal = matches ? 'center' : 'left';
  let vertical = matches ? 'top' : 'bottom';

  const closeSnackbar = () => {
    setState((prev) => ({
      ...prev,
      open: false,
      errorFields: {
        ...prev.errorFields,
        open: '',
      },
    }));
    setLoading(false);
  };

  const onChangeEvent = (event) => {
    const { name, value } = event.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmission = (event) => {
    // event.preventDefault();

    const { code, newPassword, confirmPassword } = state;

    const formData = {
      code: code,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };

    if (formValidation(formData)) {
      setLoading(true);
      changePassword(formData);
    }
  };

  async function changePassword(values) {
    try {
      let code = values.code;
      let username = params.email;
      const new_password = values.newPassword;

      // Collect confirmation code and new password, then

      // let addToRotationCheck = await passwordRotation({
      //   "action": "compare",
      //   "password": new_password
      // })
      // if (addToRotationCheck.passwordRotatedStatus) {
      //   return showWarningSnackbar("passwprdreuse")
      // }
      await Auth.forgotPasswordSubmit(username, code, new_password)
        .then(async (data) => {
          // await Auth.signIn(username, new_password).catch((err) => {
          //     navigate("/login");
          // }
          // );
          // await Auth.signIn(username, new_password)
          // let addToRotationCheck = await passwordRotation({
          //   "action": "insert",
          //   "password": new_password
          // })
          await Auth.sign;
          setState((prev) => ({
            ...prev,
            open: false,
            errorFields: {
              ...prev.errorFields,
              open: '',
            },
          }));
          setLoading(false);
          navigate('/login');
          showSuccessSnackbar('Password Changed !');
        })
        .catch((error) => {
          setState((prev) => ({
            ...prev,
            open: true,
            errorFields: {
              ...prev.errorFields,
              open: error.message,
            },
          }));
          setLoading(false);
          // showWarningSnackbar("Something Went wrong !")
        });
    } catch (error) {
      setLoading(false);

      // showWarningSnackbar("Something Went wrong !")
      console.log('error : ', error);
    }
  }

  const formValidation = (data) => {
    const passwprdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/;
    let isvalid = true;

    Object.keys(data).map((itemKey) => {
      if (itemKey === 'code') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Confirmation Code is Required',
            },
          }));
        } else if (!new RegExp(/^\d+$/).test(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Invalid Confirmation Code',
            },
          }));
        } else if (data[itemKey].trim().length > 0 && data[itemKey].trim().length !== 6) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Please enter your 6 digits code',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }

      if (itemKey === 'newPassword') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Password is Required',
            },
          }));
        } else if (!passwprdRegex.test(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
              // "Password Requires atleast one lowercase and uppercase letters,numbers and special characters, Whitespace not allowed and Minimum 8 characters, maximum 99 characters"
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }

      if (itemKey === 'confirmPassword') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Password is Required',
            },
          }));
        } else if (data['newPassword'] !== data[itemKey]) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Password not Matching',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }
    });

    return isvalid;
  };

  return (
    <Fade in={true}>
      <Box
        sx={{
          backgroundColor: '#e8e8e8',
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          alignItems: {
            xs: 'center',
            md: 'normal',
          },
          justifyContent: {
            xs: 'center',
            md: 'normal',
          },
          backgroundImage: {
            xs: `url(${loginbg})`,
            md: 'none',
          },
          width: '100%',
          minHeight: '100vh',
          padding: {
            xs: '20px 20px',
            sm: '30px 40px',
            md: '0px 0px',
          },
          boxSizing: 'border-box',
          height: '100%',
        }}
      >
        {!matches ? (
          <Box
            sx={{
              // flex : 1,
              backgroundImage: `url(${loginbg})`,
              backgroundSize: 'auto 100%',
              backgroundRepeat: 'no-repeat',
              // backgroundPosition: "right",
              width: '55%',
              height: '100dvh',
              display: 'flex',
              // justifyContent : "center",
              alignItems: 'center',
              paddingLeft: '60px',
              paddingRight: '60px',
            }}
          >
            <Box>
              <Box sx={{ textAlign: 'center', marginBottom: '30px' }}>
                <div
                  class="image"
                  style={{
                    height: '80px',
                    maxWidth: '250px',
                    backgroundImage: `url(${NewLogo})`,
                    backgroundSize: '300px',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    // margin: '0 auto',
                  }}
                ></div>
              </Box>
              <Typography sx={{ width: '60%', marginBottom: '15px', marginLeft: '40px' }}>
                We've sent you a verification code to this Email address <span style={{ color: 'blueviolet' }}>{params.email} </span> Please
                enter the code here to verify your account
              </Typography>
            </Box>
          </Box>
        ) : (
          // <Box
          //   sx={{
          //     width: {
          //       xs: '90%',
          //       sm: '80%',
          //       md: '45%',
          //       lg: '45%',
          //     },
          //     marginBottom: {
          //       xs: '30px',
          //       sm: '60px',
          //       md: '0px',
          //     },
          //   }}
          // >
          //   {/* <Typography
          //     variant="h4"
          //     sx={{
          //       color: '#3A3A3A',
          //       marginBottom: '15px',
          //       textAlign: {
          //         xs: 'center',
          //         md: 'left',
          //       },
          //     }}
          //   >
          //     Confirmation <span style={{ fontWeight: 'bold' }}>screen</span>
          //   </Typography> */}

          //   <Typography
          //     sx={{
          //       color: '#3A3A3A',
          //       marginBottom: '30px',
          //       textAlign: {
          //         xs: 'center',
          //         md: 'left',
          //       },
          //     }}
          //   >
          //     CHANGE YOUR PASSWORD <br></br>We've sent you a verification code to this Email address <span style={{}}>{params.email} </span>
          //     . Please enter the code here to verify your account
          //   </Typography>
          //   {/* {state.showCountdown ? (
          //     <Typography style={{ textAlign: 'center' }}>Resend code in {state.timer}</Typography>
          //   ) : (
          //     <Box
          //       sx={{
          //         backgroundColor: 'success.main',
          //         maxWidth: '240px',
          //         padding: '5px 15px',
          //         textAlign: 'center',
          //         borderRadius: '20px',
          //         cursor: 'pointer',
          //         margin: {
          //           xs: '0px auto',
          //           md: '0px',
          //         },
          //       }}
          //       onClick={() => resendCode()}
          //     >
          //       <Typography style={{ textDecoration: 'none' }}>Resend the code</Typography>
          //     </Box>
          //   )} */}
          // </Box>
          <></>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            // justifyContent : "center",
            width: {
              xs: '90%',
              sm: '80%',
              md: '45%',
              lg: '45%',
            },
            paddingLeft: {
              xs: '0px',
              md: '30px',
            },
            paddingRight: {
              xs: '0px',
              md: '30px',
            },
          }}
        >
          {/* Toast */}
          <Snackbar open={state.open} autoHideDuration={6000} anchorOrigin={{ horizontal, vertical }} onClose={closeSnackbar}>
            <Alert onClose={closeSnackbar} variant="filled" severity="error" sx={{ width: '100%' }}>
              {state.errorFields.open}
            </Alert>
          </Snackbar>

          <Box
            id="00000"
            sx={{
              width: '70%',
              boxShadow: '0 5px 15px rgb(0, 0, 0 , 5%)',
              backgroundColor: '#f7f7f7',
              padding: '40px',
              // backgroundColor: {
              //     xs: '#fff',
              //     md: 'transparent'
              // },
              borderRadius: '15px',
            }}
          >
            {/* <Box sx={{ textAlign: 'center', marginBottom: '30px' }}>
              <div
                class="image"
                style={{
                  height: '80px',
                  maxWidth: '250px',
                  backgroundImage: `url(${NewLogo})`,
                  backgroundSize: '250px',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  margin: '0 auto',
                }}
              ></div>
            </Box> */}
            <Box sx={{ color: theme.palette.primary.main, marginBottom: '30px', textAlign: 'center', fontWeight: 600 }}>
              CHANGE YOUR PASSWORD
            </Box>

            {/* <CustomInputBox
              name="code"
              placeholder="Confirmation code"
              type="number"
              autoFocus={true}
              autoComplete="off"
              onChange={(e) => {
                let { name, value } = e.target;
                value = value.trim();
                if (value !== "") {
                  if (!new RegExp(/^\d+$/).test(value)) {
                    setState((prev) => ({
                      ...prev,
                      [name]: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        [name]: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        [name]: "Invalid Confirmation Code",
                      },
                    }));
                  } else if (
                    value.trim().length > 0 &&
                    value.trim().length !== 6
                  ) {
                    setState((prev) => ({
                      ...prev,
                      [name]: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        [name]: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        [name]: "Please enter your 6 digits code",
                      },
                    }));
                  } else {
                    setState((prev) => ({
                      ...prev,
                      [name]: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        [name]: false,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        [name]: "",
                      },
                    }));
                  }
                } else {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: "Confirmation Code is Required",
                    },
                  }));
                }
              }}
              state={state}
              icon={
                <Security
                  sx={{
                    color:
                      state.errorStatus.code === true
                        ? "danger.main"
                        : "#8a8787",
                  }}
                  className="icon"
                />
              }
            /> */}
            <Box sx={{ marginBottom: '20px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '50px' }}>
                <Typography>Confirmation code</Typography>
                <Button
                  disabled={timeLeft > 0}
                  sx={{
                    color: 'white',
                    backgroundColor: '#75428C',
                    maxWidth: '150px',
                    padding: '12px 15px',
                    textAlign: 'center',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    height: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px',
                    '&:hover': {
                      backgroundColor: '#75428C',
                    },
                    // pointerEvents: timeLeft > 0 ? 'none' : 'auto',
                    // opacity: timeLeft > 0 ? 0.5 : 1,
                  }}
                  onClick={() => resendCode()}
                >
                  <Typography style={{ textDecoration: 'none', fontSize: '11px', color: 'white', opacity: timeLeft > 0 ? 0.5 : 1 }}>
                    Resend code
                  </Typography>
                  <CircularProgress
                    variant="determinate"
                    value={timeLeft}
                    size={15}
                    sx={{ color: 'white', display: timeLeft > 0 ? 'block' : 'none' }}
                  />
                </Button>
              </Box>
              <MuiOtpInput
                // sx={{color:"red",
                //   ".MuiInputBase-input-MuiOutlinedInput-input" :{
                //     height:"50px"
                //   }
                // }}
                autoFocus
                value={state.code}
                length={6}
                name="code"
                onChange={(value) => {
                  const cleanedValue = value.replace(/\D/g, '');
                  const name = 'code';
                  let errorMessage = '';
                  let isError = false;

                  if (!/^\d+$/.test(cleanedValue)) {
                    errorMessage = 'Confirmation Code is Required ';
                    isError = true;
                  } else if (value !== cleanedValue) {
                    errorMessage = 'Only digits allowed';
                    isError = true;
                  } else if (cleanedValue === '') {
                    errorMessage = 'Confirmation Code is Required';
                    isError = true;
                  }

                  setState((prev) => ({
                    ...prev,
                    [name]: cleanedValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: isError,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: errorMessage,
                    },
                  }));
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    height: '5px',
                    width: '100%',
                  },
                }}
              />
              {state.errorFields.code && (
                <span style={{ color: theme.palette.danger.main, fontSize: '12px' }}>{state.errorFields.code}</span>
              )}
            </Box>

            {/* <CustomInputBox
              name="code"
              placeholder="Confirmation code"
              type="text"
              autoFocus={true}
              autoComplete="off"
              maxLength={6}
              onChange={(e) => {
                let { name, value } = e.target;
                const cleanedValue = value.replace(/\D/g, '');
                if (value !== cleanedValue) {
                  setState((prev) => ({
                    ...prev,
                    [name]: cleanedValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: 'Only Digits allowed',
                    },
                  }));
                  return;
                }

                if (cleanedValue === '') {
                  setState((prev) => ({
                    ...prev,
                    [name]: cleanedValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: 'Confirmation Code is Required',
                    },
                  }));
                } else if (cleanedValue.length !== 6) {
                  setState((prev) => ({
                    ...prev,
                    [name]: cleanedValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: 'Please enter your 6 digits code',
                    },
                  }));
                } else {
                  setState((prev) => ({
                    ...prev,
                    [name]: cleanedValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: '',
                    },
                  }));
                }
              }}
              state={state}
              icon={
                <Security
                  sx={{
                    color: state.errorStatus.code === true ? 'danger.main' : '#8a8787',
                  }}
                  className="icon"
                />
              }
            /> */}
            <CustomInputBox
              name="newPassword"
              placeholder="Enter New Password"
              type={showPassword.password ? 'text' : 'password'}
              autoFocus={false}
              autoComplete="new-password"
              onChange={(e) => {
                const { name, value } = e.target;
                if (state.errorFields.confirmPassword === 'Password not Matching') {
                  setState((prev) => ({
                    ...prev,
                    errorFields: {
                      ...prev.errorFields,
                      confirmPassword: '',
                    },
                  }));
                }
                if (value == '') {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: 'Password is Required',
                    },
                  }));
                } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/.test(value)) {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: '',
                      // 'Password Requires atleast one lowercase and uppercase letters,numbers and special characters, Whitespace not allowed and Minimum 8 characters, maximum 99 characters'
                    },
                  }));
                } else {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: '',
                    },
                  }));
                }
              }}
              state={state}
              icon={
                <Lock
                  sx={{
                    color: state.errorStatus.newPassword === true ? 'danger.main' : '#8a8787',
                  }}
                  className="icon"
                />
              }
              Icon={
                <span
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      password: !showPassword.password,
                    }));
                  }}
                >
                  {showPassword.password ? (
                    <VisibilityOffIcon
                      sx={{
                        color: state.errorStatus.newPassword === true ? 'danger.main' : '#8a8787',
                      }}
                      className="iconpassword"
                    />
                  ) : (
                    <VisibilityIcon
                      sx={{
                        color: state.errorStatus.newPassword === true ? 'danger.main' : '#8a8787',
                      }}
                      className="iconpassword"
                    />
                  )}
                </span>
              }
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', m: 1 }}>
              {state?.newPassword.length > 0 && (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      marginLeft: '10px',
                      // marginTop: '5px',
                      color: /[a-z]/.test(state.newPassword) && /[A-Z]/.test(state.newPassword) ? '#0DB66E' : '#F22E07',
                    }}
                  >
                    {/[a-z]/.test(state.newPassword) && /[A-Z]/.test(state.newPassword) ? (
                      <DoneIcon style={{ fontSize: '20px' }} />
                    ) : (
                      <CloseIcon style={{ fontSize: '20px' }} />
                    )}
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: /[a-z]/.test(state.newPassword) && /[A-Z]/.test(state.newPassword) ? '#0DB66E' : '#F22E07',
                      }}
                    >
                      Must Contain Atleast 1 Uppercase & lowercase characters
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      marginLeft: '10px',
                      color: /\d/.test(state.newPassword) ? '#0DB66E' : '#F22E07',
                    }}
                  >
                    {/\d/.test(state.newPassword) ? <DoneIcon style={{ fontSize: '20px' }} /> : <CloseIcon style={{ fontSize: '20px' }} />}
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: /\d/.test(state.newPassword) ? '#0DB66E' : '#F22E07',
                      }}
                    >
                      Must Contain Atleast 1 Number
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      marginLeft: '10px',
                      color: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(state.newPassword) ? '#0DB66E' : '#F22E07',
                    }}
                  >
                    {/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(state.newPassword) ? (
                      <DoneIcon style={{ fontSize: '20px' }} />
                    ) : (
                      <CloseIcon style={{ fontSize: '20px' }} />
                    )}
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(state.newPassword) ? '#0DB66E' : '#F22E07',
                      }}
                    >
                      Must Contain Atleast 1 special character
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      marginLeft: '10px',
                      color: !/\s/g.test(state.newPassword) && state.newPassword.length > 1 ? '#0DB66E' : '#F22E07',
                    }}
                  >
                    {!/\s/g.test(state.newPassword) && state.newPassword.length > 1 ? (
                      <DoneIcon style={{ fontSize: '20px' }} />
                    ) : (
                      <CloseIcon style={{ fontSize: '20px' }} />
                    )}
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: !/\s/g.test(state.newPassword) && state.newPassword.length > 1 ? '#0DB66E' : '#F22E07',
                      }}
                    >
                      Whitespace not allowed
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      marginLeft: '10px',
                      color: state.newPassword.length >= 8 ? '#0DB66E' : '#F22E07',
                    }}
                  >
                    {state.newPassword.length >= 8 ? <DoneIcon style={{ fontSize: '20px' }} /> : <CloseIcon style={{ fontSize: '20px' }} />}
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: state.newPassword.length >= 8 ? '#0DB66E' : '#F22E07',
                      }}
                    >
                      Must be Atleast 8 characters
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
            <CustomInputBox
              name="confirmPassword"
              placeholder="Confirm New Password"
              type={showPassword.cpassword ? 'text' : 'password'}
              autoFocus={false}
              autoComplete="new-password"
              onChange={(e) => {
                const { name, value } = e.target;
                const newPassword = state.newPassword;
                if (value == '') {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: 'Password is Required',
                    },
                  }));
                } else if (value.length >= newPassword.length && value !== newPassword) {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: 'Password not Matching',
                    },
                  }));
                } else {
                  setState((prev) => ({
                    ...prev,
                    [name]: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      [name]: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      [name]: '',
                    },
                  }));
                }
              }}
              state={state}
              icon={
                <Lock
                  sx={{
                    color: state.errorStatus.confirmPassword === true ? 'danger.main' : '#8a8787',
                  }}
                  className="icon"
                />
              }
              Icon={
                <span
                  onClick={() => {
                    setShowPassword((prev) => ({
                      ...prev,
                      cpassword: !showPassword.cpassword,
                    }));
                  }}
                >
                  {showPassword.cpassword ? (
                    <VisibilityOffIcon
                      sx={{
                        color: state.errorStatus.confirmPassword === true ? 'danger.main' : '#8a8787',
                      }}
                      className="iconpassword"
                    />
                  ) : (
                    <VisibilityIcon
                      sx={{
                        color: state.errorStatus.confirmPassword === true ? 'danger.main' : '#8a8787',
                      }}
                      className="iconpassword"
                    />
                  )}
                </span>
              }
            />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '20px',
              }}
            >
              <Box sx={{ flex: 1, textAlign: 'left', padding: '10px' }}>
                <Link href="/" underline="hover" color="blue">
                  Back to Login
                </Link>
              </Box>
              <Box sx={{ flex: 1, textAlign: 'right' }}>
                {/* <Button variant="contained" disableRipple={true} onClick= {(event) => handleFormSubmission(event)}> Submit </Button> */}
                <LoadingButton
                  style={{ width: 160, height: 50 }}
                  loading={loading}
                  disableRipple={true}
                  variant="contained"
                  onClick={(event) => handleFormSubmission(event)}
                >
                  Submit
                </LoadingButton>
              </Box>
            </Box>
            {/* <Box sx={{ justifyContent: 'space-between', marginBottom: "20px", display: 'flex' }}>
                           
                            <Box sx={{ flex: 1, textAlign: 'right' }}>
                                <LoadingButton style={{ width: 160, height: 50 }} loading={loading} disableRipple={true} variant="contained" onClick={(event) => handleFormSubmission(event)}>
                                    Submit
                                </LoadingButton>
                            </Box>
                        </Box> */}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default NewPassword;
